<!-- eslint-disable max-len -->
<template>
  <div class="mx-auto min-h-full">
    <SimpleHeader
      :on-close="handleClose"
      :pages="[
        { name: t('sidemenu.navigation.crm.title'), href: router.resolve({ name: 'CRMDashboardPage' }).href, current: true },
      ]"
    />
    <PaidFeatureGate feature="crm" @allowed="contentVersion += 1">
      <RouterView :key="contentVersion" />
    </PaidFeatureGate>
  </div>
  <SimpleFooter
    :horizontal="true"
  />
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import SimpleHeader from '@/components/tailwind/header/SimpleHeader.vue';
import SimpleFooter from '@/components/tailwind/footer/SimpleFooter.vue';
import PaidFeatureGate from '@/components/tailwind/PaidFeatureGate.vue';

const router = useRouter();
const { t } = useI18n();
const contentVersion = ref(0);
const handleClose = () => router.push({ name: 'DashboardPage' });
</script>
